import { SET_WIDGET_INFO } from '../actions/types';

export default function widgetInfo(state = {}, action) {
	if (!action.error && action.payload !== undefined) {
		switch (action.type) {
			case SET_WIDGET_INFO:
				return {
					...state,
					...action.payload
				};

			// no default
		}
	}

	return state;
}
